import {Product} from "../functions/types";

export const products: Product[] = [
    {
        productCode: '040258',
        name: 'Tube',
        retainerType: 'Log',
        retainerHeight: '120',
        material: 'Aluminium',
        image: 'https://www.flender-flux.de/fileadmin/products/040258/2.jpg'
    },
    {
        productCode: '040259',
        name: 'Tube',
        retainerType: 'Log',
        retainerHeight: '120',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/040259/2.jpg'
    },
    {
        productCode: '020046',
        name: 'Tube',
        retainerType: 'Tube',
        retainerHeight: '28',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/020046/2.jpg'
    },
    {
        productCode: '020017',
        name: 'Tube',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Aluminium',
        image: 'https://www.flender-flux.de/fileadmin/products/020017/2.jpg'
    },
    {
        productCode: '020042',
        name: 'Tube',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020042/2.jpg'
    },
    {
        productCode: '020036',
        name: 'Tube',
        retainerType: 'Tube',
        retainerHeight: '35',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/020036/2.jpg'
    },
    {
        productCode: '020001',
        name: 'Grid Retainer',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020001/2.jpg'
    },
    {
        productCode: '020019',
        name: 'Grid Retainer',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020019/2.jpg'
    },
    {
        productCode: '020027',
        name: 'Grid Retainer',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/020027/2.jpg'
    },
    {
        productCode: '020003',
        name: 'Grid Retainer',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020003/2.jpg'
    },
    {
        productCode: '020020',
        name: 'Grid Retainer',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020020/2.jpg'
    },
    {
        productCode: '020005',
        name: 'Grid Retainer',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020005/2.jpg'
    },
    {
        productCode: '020006',
        name: 'Grid Retainer',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020006/2.jpg'
    },
    {
        productCode: '020022',
        name: 'Grid Retainer',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020022/2.jpg'
    },
    {
        productCode: '020028',
        name: 'Grid Retainer',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/020028/2.jpg'
    },
    {
        productCode: '020007',
        name: 'Grid Retainer',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020007/2.jpg'
    },
    {
        productCode: '020023',
        name: 'Grid Retainer',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020023/2.jpg'
    },
    {
        productCode: '020045',
        name: 'Grid Retainer Royal-Color',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020045/2.jpg'
    },
    {
        productCode: '020039',
        name: 'Grid Retainer Royal-Color',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020039/2.jpg'
    },
    {
        productCode: '020040',
        name: 'Grid Retainer Royal-Color',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/020040/2.jpg'
    },
    {
        productCode: '030029',
        name: 'Nr. 59',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030029/2.jpg'
    },
    {
        productCode: '030132',
        name: 'Nr. 59',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030132/2.jpg'
    },
    {
        productCode: '030218',
        name: 'Nr. 59',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030218/2.jpg'
    },
    {
        productCode: '030214',
        name: 'Nr. 59',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030214/2.jpg'
    },
    {
        productCode: '030045',
        name: 'Nr. 61',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030045/2.jpg'
    },
    {
        productCode: '030141',
        name: 'Nr. 61',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030141/2.jpg'
    },
    {
        productCode: '030231',
        name: 'Nr. 61',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030231/2.jpg'
    },
    {
        productCode: '030048',
        name: 'Nr. 61',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030048/2.jpg'
    },
    {
        productCode: '030142',
        name: 'Nr. 61',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030142/2.jpg'
    },
    {
        productCode: '030049',
        name: 'Nr. 62',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030049/2.jpg'
    },
    {
        productCode: '030143',
        name: 'Nr. 62',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030143/2.jpg'
    },
    {
        productCode: '030234',
        name: 'Nr. 62',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030234/2.jpg'
    },
    {
        productCode: '030051',
        name: 'Nr. 62',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030234/2.jpg'
    },
    {
        productCode: '030050',
        name: 'Nr. 62',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030050/2.jpg'
    },
    {
        productCode: '030085',
        name: 'Nr. 69',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030085/2.jpg'
    },
    {
        productCode: '030162',
        name: 'Nr. 69',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030162/2.jpg'
    },
    {
        productCode: '030074',
        name: 'Nr. 73',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030074/2.jpg'
    },
    {
        productCode: '030155',
        name: 'Nr. 73',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030155/2.jpg'
    },
    {
        productCode: '030248',
        name: 'Nr. 73',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030248/2.jpg'
    },
    {
        productCode: '030081',
        name: 'Nr. 75',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030081/2.jpg'
    },
    {
        productCode: '030160',
        name: 'Nr. 75',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030160/2.jpg'
    },
    {
        productCode: '030084',
        name: 'Nr. 76',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030084/2.jpg'
    },
    {
        productCode: '030161',
        name: 'Nr. 76',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030161/2.jpg'
    },
    {
        productCode: '030087',
        name: 'Nr. 76',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030087/2.jpg'
    },
    {
        productCode: '030164',
        name: 'Nr. 76',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030164/2.jpg'
    },
    {
        productCode: '030392',
        name: 'Nr. 173',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030392/2.jpg'
    },
    {
        productCode: '030393',
        name: 'Nr. 173',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030393/2.jpg'
    },
    {
        productCode: '030394',
        name: 'Nr. 174',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030394/2.jpg'
    },
    {
        productCode: '030395',
        name: 'Nr. 174',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030395/2.jpg'
    },
    {
        productCode: '030396',
        name: 'Nr. 175',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030396/2.jpg'
    },
    {
        productCode: '030397',
        name: 'Nr. 175',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030397/2.jpg'
    },
    {
        productCode: '030018',
        name: 'Nr. 55 B',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030018/2.jpg'
    },
    {
        productCode: '030209',
        name: 'Nr. 55 B',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030209/2.jpg'
    },
    {
        productCode: '030301',
        name: 'Nr. 69 B',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030301/2.jpg'
    },
    {
        productCode: '030307',
        name: 'Nr. 69 B',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030307/2.jpg'
    },
    {
        productCode: '030304',
        name: 'Nr. 69 C',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030304/2.jpg'
    },
    {
        productCode: '030310',
        name: 'Nr. 69 C',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030310/2.jpg'
    },
    {
        productCode: '030302',
        name: 'Nr. 75 B',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030302/2.jpg'
    },
    {
        productCode: '030308',
        name: 'Nr. 75 B',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030308/2.jpg'
    },
    {
        productCode: '030305',
        name: 'Nr. 75 C',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030305/2.jpg'
    },
    {
        productCode: '030311',
        name: 'Nr. 75 C',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030311/2.jpg'
    },
    {
        productCode: '030303',
        name: 'Nr. 76 B',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030303/2.jpg'
    },
    {
        productCode: '030309',
        name: 'Nr. 76 B',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030309/2.jpg'
    },
    {
        productCode: '030374',
        name: 'Nr. 76 B',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030374/2.jpg'
    },
    {
        productCode: '030375',
        name: 'Nr. 76 B',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030375/2.jpg'
    },
    {
        productCode: '030306',
        name: 'Nr. 76 C',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030306/2.jpg'
    },
    {
        productCode: '030312',
        name: 'Nr. 76 C',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030312/2.jpg'
    },
    {
        productCode: '030376',
        name: 'Nr. 76 C',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030376/2.jpg'
    },
    {
        productCode: '030377',
        name: 'Nr. 76 C',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030377/2.jpg'
    },
    {
        productCode: '030421',
        name: 'Nr. 169 V',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030421/2.jpg'
    },
    {
        productCode: '030423',
        name: 'Nr. 169 V',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030423/2.jpg'
    },
    {
        productCode: '030409',
        name: 'Nr. 369 V',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030409/2.jpg'
    },
    {
        productCode: '030411',
        name: 'Nr. 369 V',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030411/2.jpg'
    },
    {
        productCode: '030413',
        name: 'Nr. 375 V',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030413/2.jpg'
    },
    {
        productCode: '030415',
        name: 'Nr. 375 V',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030413/2.jpg'
    },
    {
        productCode: '030417',
        name: 'Nr. 376 V',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030417/2.jpg'
    },
    {
        productCode: '030419',
        name: 'Nr. 376 V',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030417/2.jpg'
    },
    {
        productCode: '030387',
        name: 'Nr. 176 V ',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030387/2.jpg'
    },
    {
        productCode: '030388',
        name: 'Nr. 176 V ',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030388/2.jpg'
    },
    {
        productCode: '030094',
        name: 'Nr. 81',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030094/2.jpg'
    },
    {
        productCode: '030168',
        name: 'Nr. 81',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030168/2.jpg'
    },
    {
        productCode: '030256',
        name: 'Nr. 81',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030256/2.jpg'
    },
    {
        productCode: '030095',
        name: 'Nr. 81',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030095/2.jpg'
    },
    {
        productCode: '030169',
        name: 'Nr. 81',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030169/2.jpg'
    },
    {
        productCode: '030116',
        name: 'Nr. 151',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030116/2.jpg'
    },
    {
        productCode: '030184',
        name: 'Nr. 151',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030184/2.jpg'
    },
    {
        productCode: '030279',
        name: 'Nr. 151',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030279/2.jpg'
    },
    {
        productCode: '030428',
        name: 'Nr. 161',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030428/2.jpg'
    },
    {
        productCode: '030429',
        name: 'Nr. 161',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030429/2.jpg'
    },
    {
        productCode: '030448',
        name: 'Nr. 81 V',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030448/2.jpg'
    },
    {
        productCode: '030453',
        name: 'Nr. 81 V',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030453/2.jpg'
    },
    {
        productCode: '030449',
        name: 'Nr. 81 V',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030449/2.jpg'
    },
    {
        productCode: '030454',
        name: 'Nr. 81 V',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030454/2.jpg'
    },
    {
        productCode: '030458',
        name: 'Nr. 85 V',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030458/2.jpg'
    },
    {
        productCode: '030463',
        name: 'Nr. 85 V',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030463/2.jpg'
    },
    {
        productCode: '030459',
        name: 'Nr. 85 V',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030459/2.jpg'
    },
    {
        productCode: '030464',
        name: 'Nr. 85 V',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030464/2.jpg'
    },
    {
        productCode: '030452',
        name: 'Nr. 151 V',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030452/2.jpg'
    },
    {
        productCode: '030457',
        name: 'Nr. 151 V',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030457/2.jpg'
    },
    {
        productCode: '030451',
        name: 'Nr. 161 V',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030451/2.jpg'
    },
    {
        productCode: '030456',
        name: 'Nr. 161 V',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030456/2.jpg'
    },
    {
        productCode: '030461',
        name: 'Nr. 166 V',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030461/2.jpg'
    },
    {
        productCode: '030466',
        name: 'Nr. 166 V',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030466/2.jpg'
    },
    {
        productCode: '030450',
        name: 'Nr. 81 PV',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030450/2.jpg'
    },
    {
        productCode: '030455',
        name: 'Nr. 81 PV',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030455/2.jpg'
    },
    {
        productCode: '030460',
        name: 'Nr. 85 PV',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030460/2.jpg'
    },
    {
        productCode: '030465',
        name: 'Nr. 85 PV',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030465/2.jpg'
    },
    {
        productCode: '030092',
        name: 'Nr. 80',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030092/2.jpg'
    },
    {
        productCode: '030166',
        name: 'Nr. 80',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030166/2.jpg'
    },
    {
        productCode: '030093',
        name: 'Nr. 80',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030093/2.jpg'
    },
    {
        productCode: '030167',
        name: 'Nr. 80',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030167/2.jpg'
    },
    {
        productCode: '030115',
        name: 'Nr. 150',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030115/2.jpg'
    },
    {
        productCode: '030183',
        name: 'Nr. 150',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030183/2.jpg'
    },
    {
        productCode: '030100',
        name: 'Nr. 84',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030100/2.jpg'
    },
    {
        productCode: '030174',
        name: 'Nr. 84',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030174/2.jpg'
    },
    {
        productCode: '030101',
        name: 'Nr. 84',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030101/2.jpg'
    },
    {
        productCode: '030175',
        name: 'Nr. 84',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030175/2.jpg'
    },
    {
        productCode: '030118',
        name: 'Nr. 154',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030118/2.jpg'
    },
    {
        productCode: '030186',
        name: 'Nr. 154',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030186/2.jpg'
    },
    {
        productCode: '030096',
        name: 'Nr. 82',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030096/2.jpg'
    },
    {
        productCode: '030170',
        name: 'Nr. 82',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030170/2.jpg'
    },
    {
        productCode: '030097',
        name: 'Nr. 82',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030097/2.jpg'
    },
    {
        productCode: '030171',
        name: 'Nr. 82',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030171/2.jpg'
    },
    {
        productCode: '030117',
        name: 'Nr. 152',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030117/2.jpg'
    },
    {
        productCode: '030185',
        name: 'Nr. 152',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030185/2.jpg'
    },
    {
        productCode: '030119',
        name: 'Nr. 158',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030119/2.jpg'
    },
    {
        productCode: '030187',
        name: 'Nr. 158',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030187/2.jpg'
    },
    {
        productCode: '030089',
        name: 'Nr. 77',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030089/2.jpg'
    },
    {
        productCode: '030165',
        name: 'Nr. 77',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030165/2.jpg'
    },
    {
        productCode: '030253',
        name: 'Nr. 77',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030165/2.jpg'
    },
    {
        productCode: '030090',
        name: 'Nr. 78',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030090/2.jpg'
    },
    {
        productCode: '030321',
        name: 'Nr. 78',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030321/2.jpg'
    },
    {
        productCode: '030091',
        name: 'Nr. 79',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030091/2.jpg'
    },
    {
        productCode: '030389',
        name: 'Nr. 79',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030389/2.jpg'
    },
    {
        productCode: '030370',
        name: 'Nr. 69 W',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030370/2.jpg'
    },
    {
        productCode: '030372',
        name: 'Nr. 69 W',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030372/2.jpg'
    },
    {
        productCode: '030371',
        name: 'Nr. 69 W',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030371/2.jpg'
    },
    {
        productCode: '030373',
        name: 'Nr. 69 W',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030373/2.jpg'
    },
    {
        productCode: '030430',
        name: 'Nr. 176 W',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030430/2.jpg'
    },
    {
        productCode: '030431',
        name: 'Nr. 176 W',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030431/2.jpg'
    },
    {
        productCode: '030432',
        name: 'Nr. 176 W',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030432/2.jpg'
    },
    {
        productCode: '030433',
        name: 'Nr. 176 W',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030433/2.jpg'
    },
    {
        productCode: '040248',
        name: 'Nr. 180',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/040248/2.jpg'
    },
    {
        productCode: '040249',
        name: 'Nr. 180',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/040249/2.jpg'
    },
    {
        productCode: '040250',
        name: 'Nr. 181',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/040250/2.jpg'
    },
    {
        productCode: '040251',
        name: 'Nr. 181',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/040251/2.jpg'
    },
    {
        productCode: '040252',
        name: 'Nr. 182',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/040252/2.jpg'
    },
    {
        productCode: '040253',
        name: 'Nr. 182',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/040253/2.jpg'
    },
    {
        productCode: '030484',
        name: 'Nr. 185',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030484/2.jpg'
    },
    {
        productCode: '030485',
        name: 'Nr. 185',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030485/2.jpg'
    },
    {
        productCode: '030486',
        name: 'Nr. 186',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030486/2.jpg'
    },
    {
        productCode: '030487',
        name: 'Nr. 186',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030487/2.jpg'
    },
    {
        productCode: '030488',
        name: 'Nr. 187',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030488/2.jpg'
    },
    {
        productCode: '030489',
        name: 'Nr. 187',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030489/2.jpg'
    },
    {
        productCode: '030473',
        name: 'Retainer Holder for 140 mm',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030473/2.jpg'
    },
    {
        productCode: '030445',
        name: 'Retainer holder f.Grid DECRA FL',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030445/2.jpg'
    },
    {
        productCode: '030441',
        name: 'Retainer Holder 200 Quadro FL',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030441/2.jpg'
    },
    {
        productCode: '030447',
        name: 'Retainer holderf.Log DECRA FL',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030447/2.jpg'
    },
    {
        productCode: '030446',
        name: 'Retainer holder f.Log DECRA FL',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030446/2.jpg'
    },
    {
        productCode: '030493',
        name: 'Retainer Holder for 1 Tube with 32 ',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030493/2.jpg'
    },
    {
        productCode: '030444',
        name: 'Retainer Holder f.Grid DECRA FL',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030444/2.jpg'
    },
    {
        productCode: '030440',
        name: 'Retainer Holder 200 tall Quadro FL',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030440/2.jpg'
    },
    {
        productCode: '030490',
        name: 'Retainer Holder for 1 Tube with 32 mm ',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030490/2.jpg'
    },
    {
        productCode: '030491',
        name: 'Retainer Holder for 2 Tubes with 32 mm ',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030491/2.jpg'
    },
    {
        productCode: '030494',
        name: 'Retainer Holder for 2 Tubes with 32 mm ',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030494/2.jpg'
    },
    {
        productCode: '030492',
        name: 'Retainer Holder for 3 Tubes with 32 mm ',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030492/2.jpg'
    },
    {
        productCode: '030495',
        name: 'Retainer Holder for 3 Tubes with 32 mm ',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030495/2.jpg'
    },
    {
        productCode: '030252',
        name: 'Clamp Raiser',
        retainerType: 'Tube',
        retainerHeight: '28',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030252/2.jpg'
    },
    {
        productCode: '030286',
        name: 'Clamp Raiser',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Aluminium',
        image: 'https://www.flender-flux.de/fileadmin/products/030286/2.jpg'
    },
    {
        productCode: '030285',
        name: 'Snowstop Clamp',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Aluminium',
        image: 'https://www.flender-flux.de/fileadmin/products/030285/2.jpg'
    },
    {
        productCode: '030251',
        name: 'Snowstop Clamp',
        retainerType: 'Tube',
        retainerHeight: '28',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030251/2.jpg'
    },
    {
        productCode: '030474',
        name: 'Retainer Holder for 140 mm',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030474/2.jpg'
    },
    {
        productCode: '030476',
        name: 'Retainer Holder 200 h',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030476/2.jpg'
    },
    {
        productCode: '030475',
        name: 'Retainer Holder 200 tall',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030475/2.jpg'
    },
    {
        productCode: '030477',
        name: 'Retainer Holder for 1-Tube',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030477/2.jpg'
    },
    {
        productCode: '030478',
        name: 'Retainer Holder for 1-Tube',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030478/2.jpg'
    },
    {
        productCode: '030471',
        name: 'Retainer Holder for 2-Tubes',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030471/2.jpg'
    },
    {
        productCode: '030472',
        name: 'Retainer Holder for 2-Tubes',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030472/2.jpg'
    },
    {
        productCode: '030009',
        name: 'Nr. 55',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030009/2.jpg'
    },
    {
        productCode: '030204',
        name: 'Nr. 55',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030204/2.jpg'
    },
    {
        productCode: '030033',
        name: 'Nr. 60',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030033/2.jpg'
    },
    {
        productCode: '030134',
        name: 'Nr. 60',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030134/2.jpg'
    },
    {
        productCode: '030035',
        name: 'Nr. 60',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030035/2.jpg'
    },
    {
        productCode: '030221',
        name: 'Nr. 60',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030221/2.jpg'
    },
    {
        productCode: '030034',
        name: 'Nr. 60',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030034/2.jpg'
    },
    {
        productCode: '030135',
        name: 'Nr. 60',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030135/2.jpg'
    },
    {
        productCode: '030241',
        name: 'Nr. 70',
        retainerType: 'Tube',
        retainerHeight: '35',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030241/2.jpg'
    },
    {
        productCode: '030073',
        name: 'Nr. 72',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030073/2.jpg'
    },
    {
        productCode: '030154',
        name: 'Nr. 72',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030154/2.jpg'
    },
    {
        productCode: '030247',
        name: 'Nr. 72',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Copper',
        image: 'https://www.flender-flux.de/fileadmin/products/030247/2.jpg'
    },
    {
        productCode: '030314',
        name: 'Nr. 69 S',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030314/2.jpg'
    },
    {
        productCode: '030317',
        name: 'Nr. 69 S',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030317/2.jpg'
    },
    {
        productCode: '030315',
        name: 'Nr. 75 S',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030315/2.jpg'
    },
    {
        productCode: '030318',
        name: 'Nr. 75 S',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030318/2.jpg'
    },
    {
        productCode: '030316',
        name: 'Nr. 76 S',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030316/2.jpg'
    },
    {
        productCode: '030319',
        name: 'Nr. 76 S',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030319/2.jpg'
    },
    {
        productCode: '030422',
        name: 'Nr. 169 S',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030422/2.jpg'
    },
    {
        productCode: '030424',
        name: 'Nr. 169 S',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030424/2.jpg'
    },
    {
        productCode: '030357',
        name: 'Nr. 176 S',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030357/2.jpg'
    },
    {
        productCode: '030360',
        name: 'Nr. 176 S',
        retainerType: 'Grid',
        retainerHeight: '250',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030360/2.jpg'
    },
    {
        productCode: '030410',
        name: 'Nr. 369 S',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030410/2.jpg'
    },
    {
        productCode: '030412',
        name: 'Nr. 369 S',
        retainerType: 'Tube',
        retainerHeight: '32',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030412/2.jpg'
    },
    {
        productCode: '030414',
        name: 'Nr. 375 S',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030414/2.jpg'
    },
    {
        productCode: '030416',
        name: 'Nr. 375 S',
        retainerType: 'Log',
        retainerHeight: '140',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030416/2.jpg'
    },
    {
        productCode: '030418',
        name: 'Nr. 376 S',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Zink Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030418/2.jpg'
    },
    {
        productCode: '030420',
        name: 'Nr. 376 S',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030420/2.jpg'
    },
    {
        productCode: '030401',
        name: 'Nr. 165',
        retainerType: 'Grid',
        retainerHeight: '200',
        material: 'Painted Steel',
        image: 'https://www.flender-flux.de/fileadmin/products/030401/2.jpg'
    }
]